import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'

import CartStore from '@/lib/alpine/stores/cart-store'
import SiteStore from '@/lib/alpine/stores/site-store'
import RecentlyViewedStore from '@/lib/alpine/stores/recently-viewed'

import Header from '@/lib/alpine/components/header'
import Footer from '@/lib/alpine/components/footer'
import Product from '@/lib/alpine/components/product'
import HeroCarousel from '@/lib/alpine/components/product-carousel'
import NewsletterForm from '@/lib/alpine/components/newsletter-form'
import ProductForm from '@/lib/alpine/components/product-form'
import ProductCard from '@/lib/alpine/components/product-card'
import QuickAddForm from '@/lib/alpine/components/quick-add-form'
import Select from '@/lib/alpine/components/select'
import RecommendedProducts from '@/lib/alpine/components/related-products'
import Collection from '@/lib/alpine/components/collection'
import Component from '@/lib/alpine/components/component'
import Blog from '@/lib/alpine/components/blog'
import Marquee from '@/lib/alpine/components/marquee'
import Accordion from '@/lib/alpine/components/accordion'
import MobileMenu from '@/lib/alpine/components/mobileMenu'
import InfiniteScroll from '@/lib/alpine/components/infinite-scroll'
import ProductCarousel from '@/lib/alpine/components/product-carousel'
import PredictiveSearch from '@/lib/alpine/components/predictive-search'

export function setupAlpine() {
	// Plugins
	Alpine.plugin(intersect)
	Alpine.plugin(focus)

	// Stores
	Alpine.store('cart', CartStore)
	Alpine.store('site', SiteStore)
	Alpine.store('recentlyViewed', RecentlyViewedStore)

	// Components
	Alpine.data('Header', Header)
	Alpine.data('Footer', Footer)
	Alpine.data('Product', Product)
	Alpine.data('HeroCarousel', HeroCarousel)
	Alpine.data('ProductForm', ProductForm)
	Alpine.data('QuickAddForm', QuickAddForm as any)
	Alpine.data('Select', Select)
	Alpine.data('NewsletterForm', NewsletterForm)
	Alpine.data('RecommendedProducts', RecommendedProducts)
	Alpine.data('Collection', Collection)
	Alpine.data('Component', Component)
	Alpine.data('Blog', Blog)
	Alpine.data('Marquee', Marquee)
	Alpine.data('Accordion', Accordion)
	Alpine.data('ProductCarousel', ProductCarousel)
	Alpine.data('MobileMenu', MobileMenu)
	Alpine.data('InfiniteScroll', InfiniteScroll)
	Alpine.data('ProductCard', ProductCard)
	Alpine.data('PredictiveSearch', PredictiveSearch)
	Alpine.start()

	// Initialize cart store after Alpine starts
	;(Alpine.store('cart') as any).init()
}
